import React from 'react';

export default function KpiCard({ label, value, suffix = '', trend, color }) {
  const c = color || (trend > 0 ? '#34d399' : trend < 0 ? '#f87171' : '#00d4ff');
  return (
    <div className="card" style={{ minWidth: 160 }}>
      <div style={{ fontSize: 13, color: '#8b8fa3', marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color: c }}>
        {typeof value === 'number' ? value.toLocaleString('hu-HU', { maximumFractionDigits: 2 }) : value}
        {suffix && <span style={{ fontSize: 14, fontWeight: 400, marginLeft: 4 }}>{suffix}</span>}
      </div>
      {trend !== undefined && (
        <div style={{ fontSize: 12, color: trend >= 0 ? '#34d399' : '#f87171', marginTop: 4 }}>
          {trend >= 0 ? '▲' : '▼'} {Math.abs(trend).toFixed(1)}%
        </div>
      )}
    </div>
  );
}
